// // --------------- LIBRARIES ---------------
import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from '@redux-saga/core'

// // --------------- ASSETS ---------------
import rootReducer from './reducers'
import rootSaga from './sagas'

// Middlewares setup
const sagaMiddleware = createSagaMiddleware()

// Create store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
})

//Run the saga
sagaMiddleware.run(rootSaga) // Run Saga
